var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.035 0C7.195-.03.659 5.989.046 13.804c-.612 7.815 4.905 14.78 12.653 15.972V19.308H8.89v-4.333h3.81v-3.298c0-3.75 2.233-5.828 5.654-5.828 1.123.015 2.242.115 3.35.297v3.687h-1.885a2.161 2.161 0 0 0-2.438 2.335v2.807h4.19l-.666 4.333H17.42v10.468c7.703-1.254 13.154-8.209 12.53-15.988C29.328 6.009 22.84.011 15.035 0z","fill":"#339","fillRule":"nonzero"}));
}

Fb.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Fb;

Fb.default = Fb;
